module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-swipe', {
    style: ('margin-top:-2.6rem'),
    attrs: {
      "indicator-color": "#FD2840",
      "duration": _vm.duration
    }
  }, _vm._l((_vm.content), function(item, index) {
    return _c('van-swipe-item', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": item.pic_url,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.onRbLink(item)
        }
      }
    })])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7596bf2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/SlidePics.vue
// module id = 2612
// module chunks = 0